import React from "react";

import { CloseOutlined } from "@ant-design/icons";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import StyledTooltip from "../../../../Common/UIComponents/StyledTooltip";
import "./TestList.css";

export default function TestList(props) {
  const {
    removableTests, nonRemovableTests, loading, handleRemoveAddedTest,
  } = props;

  return (
    <StyledScrollbar id="TestList__ScrollBar" className="TestList__SelectedListScrollbar">
      <ul className="TestList__SelectedList">
        {removableTests.map((test) => (
          <StyledTooltip
            placement="top"
            key={test}
          >
            <li className="TestList__SelectedListItem">
              {test}
              <div
                className="TestList__SelectedItemCloseIcon"
                onClick={loading ? null : () => handleRemoveAddedTest(test)}
              >
                <CloseOutlined className="TestList__SelectedItemCloseIconGlyph" />
              </div>
            </li>
          </StyledTooltip>
        ))}
        {nonRemovableTests.map((test) => (
          <StyledTooltip
            placement="top"
            key={test}
          >
            <li className="TestList__SelectedListItem TestList__SelectedListItem--disabled">
              {test}
            </li>
          </StyledTooltip>
        ))}
      </ul>
    </StyledScrollbar>
  );
}
